export const ConsoleLogger = {
    warn (...args) {
        console.log(...args);
    },
    info (...args) {
        console.info(...args);
    },
    error (...args) {
        console.error(...args);
    },
    table (...args) {
        console.table(...args);
    }
};

//# sourceMappingURL=Console.js.map